module.exports = __webpack_public_path__ + "static/roadmap-portal-large-c4b38f51f860c44c80d73d824797a2b0.png";